import { SEARCH_API_URL } from '../../constants/keys'
import { getCustomer } from '../../helpers'

export const fetchOsearch = (query, filters, pageNumber, pageLength) => {
  const customerName = getCustomer()
  return fetch(`${SEARCH_API_URL}/osearch`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      index: customerName?.toLowerCase(),
      project: 'ca', // 'ca' for agentai, 'acad' for selfservice
      query,
      ...(Object.keys(filters || {}).length && { filters }),
      aggs: {
        manufacturer: {
          terms: {
            field: 'manufacturer',
            size: 100,
            order: {
              _count: 'desc'
            }
          }
        },
        phone_type: {
          terms: {
            field: 'phone_type',
            size: 100,
            order: {
              _count: 'desc'
            }
          }
        },
        model: {
          terms: {
            field: 'model',
            size: 100,
            order: {
              _count: 'desc'
            }
          }
        }
      },
      from: pageNumber || 0,
      size: pageLength || 10
    })
  })
    .then(response => response.json())
    .catch(err => err)
}

export const fetchAutoSuggest = query => {
  const customerName = getCustomer()
  return fetch(
    `${SEARCH_API_URL}/osautosuggest?query=${encodeURIComponent(
      query
    )}&index=${encodeURIComponent(customerName?.toLowerCase())}`
  )
    .then(response => response.json())
    .then(data =>
      Array.isArray(data.suggestions)
        ? data.suggestions.map(item => item.name)
        : []
    )
    .catch(() => [])
}
